import { render, staticRenderFns } from "./关于我们.vue?vue&type=template&id=33bf23be&scoped=true"
import script from "./关于我们.vue?vue&type=script&lang=js"
export * from "./关于我们.vue?vue&type=script&lang=js"
import style0 from "./关于我们.vue?vue&type=style&index=0&id=33bf23be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf23be",
  null
  
)

export default component.exports